import { Certification } from "./Certification";

export class SecondCellCertif {
  id;
  certifs1:Array<Certification>;
  certifs2:any;
  cash_flow_id;
  constructor() {
      
  }
}
